export default class MediaApi {

    static url = (url, opt) => {
        let mediaPath = requireOptions.globalOptions.mediaVirtualPath;
        let mediaUrl = "";

        if (!url || url === null) {
            mediaUrl = mediaPath + requireOptions.globalOptions.defaultImage;
        } else if (/^https?:\/\//.test(url)) {
            mediaUrl = url;
        } else {
            mediaUrl = mediaPath + "/" + url;
        }

        if (opt) {
            mediaUrl = mediaUrl + "?" + $.param(opt);
        }

        return mediaUrl;
    };

    static srcset = (url, ratio) => {
        let sizes = [160, 320, 640, 960, 1024, 1200, 1600];

        if (ratio) {
            return sizes.map(x => `${MediaApi.url(url, { w: x, h: (x * ratio).toFixed() })} ${x}w`).concat(', ');
        }
        else {
            return sizes.map(x => `${MediaApi.url(url, { w: x })} ${x}w`).concat(', ');
        }
    };
}